<div class="container relative">
    <div class="grid grid-cols-1 pb-8 text-center">
        <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Popular Rental Destinations</h3>
        <p class="text-slate-400 max-w-xl mx-auto">Discover our most popular locations for short-term stays, from cozy apartments to luxury vacation homes!</p>
    </div>

    <div class="grid grid-cols-1 relative mt-6">
        <div class="tiny-five-item">
            <div *ngFor="let item of destination" class="tiny-slide">
                <div class="group relative overflow-hidden rounded-md shadow dark:shadow-gray-800 m-2">
                    <img [src]="item.image" class="w-full h-72 object-cover scale-125 group-hover:scale-100 duration-500" alt="">
                    <div class="absolute inset-0 bg-gradient-to-b to-slate-900 from-transparent opacity-0 group-hover:opacity-100 duration-500"></div>
                    <div class="absolute p-4 bottom-0 start-0">
                        <a [routerLink]="[]" class="text-lg font-medium text-white hover:text-red-500 duration-500 ease-in-out">{{item.place}}</a>
                        <p class="text-white/70 group-hover:text-white text-sm duration-500">{{item.hotel}} • Starting from ${{item.price}}/night</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
